import React from "react";
import { useI18n } from "@/i18n/I18nProvider";
import { ShoppingBag, Briefcase, Factory, Network, UtensilsCrossed, Stethoscope, Building2, GraduationCap } from "lucide-react";

const ICONS = [ShoppingBag, Briefcase, Factory, Network, UtensilsCrossed, Stethoscope, Building2, GraduationCap];

const Industries = () => {
  const { t } = useI18n();
  return (
    <section id="industries" className="py-20 md:py-32 bg-[#F5F7FA]">
      <div className="zdc-container">
        <div className="text-center max-w-2xl mx-auto mb-12 md:mb-16">
          <div className="text-xs font-medium uppercase tracking-[0.18em] text-[#2563EB] mb-3">{t.industries.eyebrow}</div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-[#111111]">
            {t.industries.title}
          </h2>
          <p className="mt-4 text-base md:text-lg text-[#6B7280]">{t.industries.subtitle}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {t.industries.items.map((it, i) => {
            const Icon = ICONS[i] || Building2;
            return (
              <div
                key={i}
                data-testid="industry-card"
                className="group p-6 bg-white rounded-2xl border border-[#E5E7EB] card-hover hover:border-[#2563EB]/30"
              >
                <div className="w-11 h-11 rounded-xl bg-[#F5F7FA] flex items-center justify-center group-hover:bg-[#2563EB] transition-colors mb-4">
                  <Icon className="w-5 h-5 text-[#111111] group-hover:text-white transition-colors" strokeWidth={1.75} />
                </div>
                <h3 className="font-display text-base font-semibold text-[#111111] mb-1.5">{it.title}</h3>
                <p className="text-xs md:text-sm text-[#6B7280] leading-relaxed">{it.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Industries;
